import { ClipboardIcon } from "@heroicons/react/24/outline"

import { DashboardContent } from "../Dashboard/DashboardContent"
import { Bee } from "~/src/components/BeeKit"
import { MainHeading } from "~/src/components/MainHeading"

//region Types
/*
export type DashboardStorefrontInsightsProps = {
  ...
}
*/
//endregion

//region Component

// Placeholder component for the panels the work is being done in https://brilliantmade.atlassian.net/browse/BRL-7771
// Panel should have full width and height, it will auto expand to fill the grid cell
function PanelPlaceholder({ title }: { title: string }) {
  return (
    <div className="flex h-full w-full items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-400">
      {title}
    </div>
  )
}

export function DashboardStorefrontInsightsShow() {
  //region Event Handlers
  //endregion

  //region JSX
  return (
    <DashboardContent className="space-y-6 p-4 @container">
      <MainHeading
        title="Storefront Insights"
        description="The information below is a snapshot of your storefront performance. To see all order, user & product data, generate a report."
        className="ml-0 mr-auto"
      />
      {/* Top level filters + Report button */}
      <div className="flex flex-col gap-3 @sm:flex-row @sm:items-center @sm:justify-between">
        {/* Filters */}
        <div className="flex w-full flex-col gap-3 @sm:basis-1/3 @sm:flex-row @sm:gap-3">
          <div className="w-full @sm:basis-1/2">
            {/* Replace Button with store filter component https://brilliantmade.atlassian.net/browse/BRL-7799 */}
            <Bee.Button className="w-full" kind="secondary">
              All stores ▾
            </Bee.Button>
          </div>

          <div className="w-full @sm:basis-1/2">
            {/* Replace Button with date range filter component https://brilliantmade.atlassian.net/browse/BRL-7798 */}
            <Bee.Button className="w-full" kind="secondary">
              All time ▾
            </Bee.Button>
          </div>
        </div>

        {/* Generate Report Button */}
        <div className="flex @sm:basis-1/3 @sm:flex-row @sm:justify-end">
          <Bee.Button className="flex w-full items-center justify-center @sm:basis-1/2" kind="secondary">
            <ClipboardIcon className="mr-2 h-4 w-4" />
            Generate report
          </Bee.Button>
        </div>
      </div>
      {/* Grid Layout for Panels */}
      <div className="grid auto-rows-[12rem] grid-cols-1 gap-6 @md:grid-cols-2">
        <section className="@md:col-span-2">
          <PanelPlaceholder title="Overview Panel" />
        </section>

        <section className="row-span-2">
          <PanelPlaceholder title="Orders Volume Panel" />
        </section>
        <section className="row-span-2">
          <PanelPlaceholder title="Popular Products Panel" />
        </section>

        <section className="row-span-2">
          <PanelPlaceholder title="Top Users Panel" />
        </section>
        <section className="row-span-2">
          <PanelPlaceholder title="Shipping Destinations Panel" />
        </section>

        <section className="row-span-2">
          <PanelPlaceholder title="Recipient Reactions Panel" />
        </section>
        <section className="row-span-2">
          <PanelPlaceholder title="Thank You Notes Panel" />
        </section>
      </div>
    </DashboardContent>
  )
  //endregion
}
//endregion

//region Private
//endregion
